export default "__VITE_ASSET__tEVb4vte__"